import page from '@/mixins/page';
import Swiper from 'swiper';

import { TToggle, TToggleButton, TToggleContent } from '@/components/TToggle';
import { mapMutations, mapState } from 'vuex';

/**
 * @module pages/tech/tech012
 * @desc 사업영역 > PC사업
 * @vue-data {Boolean} isFixed=false - 서브탭 fixed 상태 값
 * @vue-data {Number} activateTabIdx=0 - 활성화된 탭 인덱스
 * @vue-data {Array} processPcTabActArr=Array - PC 공법 내부 탭 상태 값
 * @vue-data {Array} processHcsTabActArr=Array - HCS 공법 내부 탭 상태 값
 * @vue-data {Array} buildCatgActArr=Array - 시공 사례 내부 탭 상태 값
 * @vue-data {Array} selectOptions=Array - 시공 사례 내부 셀렉트 박스 목록 구성 값
 * @vue-data {Array} selectYear=Array - 시공 사례 내부 탭 당 셀렉트 박스 선택 값
 * @vue-data {Array} maxLength=Array - 시공 사례 내부 탭 당 리스트 최대 값
 * @vue-data {Array} video=Array - 영상 on/off 상태 값
 * @vue-computed {Number} scrollTop - 현재 스크롤
 * @vue-computed {Number} headerH - 헤더 height
 */
export default {
  mixins    : [page],
  components: {
    TToggle,
    TToggleButton,
    TToggleContent
  },
  data() {
    return {
      isFixed            : false,
      activateTabIdx     : 0,
      processPcTabActArr : Array.from({ length: 2 }, (item, idx) => idx === 0),
      processHcsTabActArr: Array.from({ length: 2 }, (item, idx) => idx === 0),
      buildCatgActArr    : Array.from({ length: 4 }, (item, idx) => idx === 0),
      selectOptions      : [
        [
          2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2011, 2010,
          2009, 2008
        ],
        [2014, 2013, 2012, 2009],
        [
          2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012,
          2011, 2010, 2009, 2008
        ],
        [2023, 2019, 2018]
      ],
      selectYear: new Array(4).fill(null),
      maxLength : new Array(4).fill(10),
      video     : new Array(3).fill(null)
    };
  },
  computed: {
    ...mapState('view', {
      scrollTop: 'scrollTop',
      headerH  : (state) => state.header.height
    })
  },
  watch: {
    scrollTop(value) {
      this.$nextTick(() => {
        this.isFixed = value >= this.$refs.visualRef.clientHeight;
      });
    },
    selectYear() {
      this.maxLength = new Array(4).fill(10);
    }
  },
  mounted() {
    // if (this.$route.query.subTab > 0) {
    //   if (this.$route.hash === '#tab1' || this.$route.hash === '') {
    //     this.processPcTabActArr = this.processPcTabActArr.map(
    //       (item, idx) => Number(this.$route.query.subTab) === idx
    //     );
    //   } else if (this.$route.hash === '#tab2') {
    //     this.processHcsTabActArr = this.processHcsTabActArr.map(
    //       (item, idx) => Number(this.$route.query.subTab) === idx
    //     );
    //   } else if (this.$route.hash === '#tab3') {
    //     this.buildCatgActArr = this.buildCatgActArr.map(
    //       (item, idx) => Number(this.$route.query.subTab) === idx
    //     );
    //   }
    // }

    this.$nextTick(() => {
      if (this.$route.query.scrollTo) {
        const target = document.querySelector(this.$route.query.scrollTo);
        let val = 82;
        if (this.device === 'mo') {
          if (this.$route.query.scrollTo === '#factory1') {
            val =
              document.querySelector('.tab_area').clientHeight +
              document.querySelector('#headerWrap').clientHeight;
          }
        }
        setTimeout(function() {
          window.scrollTo(0, target.offsetTop - val);
        }, 100);
      }
    });

    const arr = [
      this.$refs.techSlide1,
      this.$refs.techSlide2,
      this.$refs.techSlide3,
      this.$refs.techSlide4,
      this.$refs.techSlide5,
      this.$refs.techSlide6,
      this.$refs.techSlide7,
      this.$refs.techSlide8
    ];
    let options = {};
    arr.forEach((val, idx) => {
      if (this.device === 'mo') {
        options = {
          loop         : true,
          slidesPerView: 'auto',
          spaceBetween : 10,
          pagination   : {
            el: '.tech-paging'
          },
          lazy: {
            loadPrevNext: true
          }
        };
      } else if (idx % 2) {
        options = {
          slidesPerView: 'auto',
          spaceBetween : 20,
          freemode     : false,
          loop         : true,
          controller   : {
            control: arr[idx - 1].swiper
          },
          lazy: {
            loadPrevNext      : true,
            loadPrevNextAmount: 4
          }
        };
      } else {
        options = {
          loop         : true,
          slidesPerView: 'auto',
          spaceBetween : 10,
          navigation   : {
            nextEl: val.nextSibling.childNodes[1],
            prevEl: val.nextSibling.childNodes[0]
          },
          lazy: {
            loadPrevNext: true
          }
        };
      }
      new Swiper(val, options);
      if (idx % 2 && this.device === 'pc') {
        arr[idx - 1].swiper.controller.control = arr[idx].swiper;
      }
    });

    // 시공사례 최신 것 부터 보여주게 수정
    this.selectYear = this.selectOptions.map((item) => item[0] || null);
  },
  methods: {
    ...mapMutations('view', {
      setHeaderOpen  : 'SET_HEADER_OPEN',
      setHeaderFamily: 'SET_HEADER_FAMILY'
    }),
    /**
     * 탭 조작 시 활성화 된 탭 업데이트 및 init 실행
     * @param {Object} params 탭 상태 값
     * @param {Number} params.act 활성화 된 탭 인덱스
     */
    onChangeTab({ act }) {
      this.activateTabIdx = act;
      this.video = [false, false, false];
      this.initTween(act);

      this.setHeaderOpen(false);
      /* setTimeout(() => {
        window.scrollTo(0, this.$refs.visualRef.clientHeight);
      }, 1); */
      switch (act) {
        case 0 :
          this.changeProcessPcTab({ acts: this.processPcTabActArr });
          break;
        case 1 :
          this.changeProcessHcsTab({ acts: this.processHcsTabActArr });
          break;
        case 3 :
          this.changeBuildCatg({ acts: this.buildCatgActArr });
          break;
        default :
          break;
      }

      this.$nextTick(() => {
        this.swiperUpdate();
      });

      if (this.device === 'pc') {
        this.setHeaderFamily(false);
      }
    },
    /**
     * PC 공법 프로세스 탭 제어
     * @param {Object} params 탭 상태 값
     * @param {Array} params.acts processPcTabActArr 배열 값
     */
    changeProcessPcTab({ acts }) {
      this.processPcTabActArr = [...acts];
      this.subTabChange(acts);
      if (this.processPcTabActArr[0] === true) {
        this.video = [true, false, false];
      } else {
        this.video = [false, true, false];
      }
    },
    /**
     * HCS 생산 프로세스 탭 제어
     * @param {Object} params 탭 상태 값
     * @param {Array} params.acts processHcsTabActArr 배열 값
     */
    changeProcessHcsTab({ acts }) {
      this.processHcsTabActArr = [...acts];
      this.subTabChange(acts);
      this.video = [false, false, true];
    },
    /**
     * 시공사례 프로세스 탭 제어
     * @param {Object} params 탭 상태 값
     * @param {Array} params.acts buildCatgActArr 배열 값
     */
    changeBuildCatg({ acts }) {
      this.buildCatgActArr = [...acts];
      this.subTabChange(acts);
    },
    /**
     * 탭 조작에 따라 쿼리 문자열 변경
     * @param {Array} acts 조작 된 탭 배열
     */
    subTabChange(acts) {
      this.$nextTick(() => {
        this.swiperUpdate();
      });
      const { pathname } = window.location;
      const lastPath = pathname.replaceAll(/(.+)\/|(\/)/g, '');
      const hash = location.hash; //해시
      let { search } = window.location; // 기존 쿼리
      let newQuery = ''; //새로 들어갈 쿼리

      //쿼리에 subTab 문자 있는지 확인 후 없으면 추가
      if (search.indexOf('subTab') === -1) {
        if (search.indexOf('?') >= 0) {
          search += '&subTab=0';
        } else {
          search = '?subTab=0';
        }
      }
      // 새 쿼리 문자열 작성
      search.split('&').forEach((el, idx, arr) => {
        if (el.indexOf('subTab') >= 0) {
          newQuery += `${el.split('=')[0]}=${acts.indexOf(true)}&`;
        } else {
          newQuery += `${el}&`;
        }
        //마지막 & 문자 제거
        if (idx === arr.length - 1) {
          newQuery = newQuery.slice(0, -1);
        }
      });

      setTimeout(function() {
        history.replaceState(null, '', `${lastPath + newQuery + hash}`);
      }, 50);
    },
    /**
     * 스와이프 업데이트
     */
    swiperUpdate() {
      for (const key in this.$refs) {
        const target = this.$refs[key];
        if (target.offsetParent !== null && target.swiper !== undefined) {
          target.swiper.update();
        }
      }
    },
    /**
     * 더보기 버튼 클릭 시 10개씩 목록 업데이트
     */
    moreBtn() {
      let arr = [];
      this.maxLength.forEach((el, idx) => {
        arr[idx] = el;
      });
      arr[this.buildCatgActArr.indexOf(true)] += 10;
      this.maxLength = arr;
    }
  }
};
